import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-shouhou",
  "use": "icon-user-shouhou-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-user-shouhou\"><defs><style>#icon-user-shouhou .a,#icon-user-shouhou .b{fill:none;}#icon-user-shouhou .a{stroke:currentColor;}</style></defs><g transform=\"translate(-497 -274)\"><g transform=\"translate(505 280)\"><path class=\"a\" d=\"M-5470.811,14103.729a15.563,15.563,0,0,1-3.178,1.727,24.551,24.551,0,0,1-4,1.1v9.785a14.206,14.206,0,0,0,2.93,3.105,21.88,21.88,0,0,0,4.248,2.383,22,22,0,0,0,4.228-2.383,14.636,14.636,0,0,0,2.951-3.105v-9.785a24.388,24.388,0,0,1-4.343-1.1A9.136,9.136,0,0,1-5470.811,14103.729Z\" transform=\"translate(5477.989 -14103.729)\" /><path class=\"a\" d=\"M-5527.128,14106.746l3.621,3.674,4.9-4.9\" transform=\"translate(5530.046 -14098.815)\" /></g><rect class=\"b\" width=\"30\" height=\"30\" transform=\"translate(497 274)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/user-shouhou.svg
// module id = 9ywm
// module chunks = 82